import { useMediaQuery } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react'
import { onlyNumeric } from '../../../../commonClass/CommonValidation';
import { getAllData, postUsersData, verifytoken } from '../../../../../services/ApiCallingUserServices';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../../_actions/loader.actions';
import { ClearLocalStorage, GetLocalStorage } from '../../../../commonClass/Session';

function APISetSequencing({useradd,useredit}) {
    const dispatch = useDispatch();
    const [APISequencing, setAPISequencing] = useState([]);
    const [formError, setFormError] = useState({});
    const [saveDisable, setSaveDisable] = useState(false);
    const [seqData, setSeqData] = useState([])

    const getData = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const data = await getAllData('/master/v1/getallhotelsequenceconfig');
            if (data.status) {
                const userdata = GetLocalStorage();
                const updateSequenceData = [...data?.data?.map((param) => ({ ...param, UserId: userdata?.userMasterID }))]
                setAPISequencing(updateSequenceData);
                setSeqData(updateSequenceData)
                setSaveDisable(true);
            }
            else {
                dispatch({ type: 'ALERTING', message: data.message })
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end())
    }

    useEffect(() => {
        getData();
    }, [])

    const handleOnChnage = (id, name, value) => {
        setAPISequencing([
            ...APISequencing.map((data) => {
                if (id === data.HotelSequenceId) {
                    data = { ...data, [name]: value }
                }
                return data
            })
        ]);
        setFormError({});
        setSaveDisable(false);
    }

    const totalWeightage = useMemo(() =>
        APISequencing?.reduce((acc, value) => acc + (value?.Weightage ? value.Weightage : 0), 0)
        , [APISequencing]);


        
        const handleSave = async (formData) => {
            const isDub = APISequencing.map((param) => param.Weightage);
            const duplicatesIndexes = isDub.map((value, index) => ({ value, index })).filter((item, _, self) => self.some((other, i) => i !== item.index && other.value === item.value))
            .map(item => item.index);

            if (duplicatesIndexes.length <= 0) {
                let statusoftoken = await verifytoken();
                if (statusoftoken) {
                    dispatch(loaderActions.start());
                    const data = await postUsersData('/master/v1/updateallhotelsequenceconfig', { SequenceConfigs: formData });
                    if (data.status) {
                        dispatch(loaderActions.end());
                        setSaveDisable(true);
                        setSeqData(formData)
                        dispatch({ type: 'ALERTING', message: data.message })
                    }
                    else {
                        dispatch(loaderActions.end());
                        dispatch({ type: 'ALERTING', message: data.message })
                    }
                }
                else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
            dispatch(loaderActions.end())
            
        } else {
            setFormError({
                ...duplicatesIndexes.reduce((acc, index) => {
                    acc[index] = 'Weightage cannot be same for different parameter';
                    return acc;
                }, {})
            });
        }
    }
    
    const handleReset = () => {
        setAPISequencing(seqData);
        setSaveDisable(true)
        setFormError({})
    }

    const parameterWeightage=(data) => data.filter((param) => param.Weightage > 0)?.length
    const isSaveDisable = parameterWeightage(APISequencing) === APISequencing.length && totalWeightage === 100 ? false : true
    return (
        <div className='p-3 m-2 d-flex justify-content-center'>
            <div className='mx-auto w-50 place-items-center'>
                <table class="table  table-bordered">
                    <thead>
                        <tr className='' style={{ backgroundColor: '#007bff', color: '#ffffff' }}>
                            <th scope="col">Parameter</th>
                            <th scope="col">Weightage</th>
                            <th scope="col">Status</th>
                        </tr>
                    </thead>

                    <tbody>
                        {APISequencing.length > 0 && APISequencing.map((parem, index) => (
                            <tr key={parem.HotelSequenceName}>
                                <th className='align-content-center' scope="row">{parem.HotelSequenceName}</th>
                                <td className='align-content-center'>
                                    <input
                                        name='Weightage'
                                        className='form-control'
                                        placeholder='Weightage'
                                        id={parem.HotelSequenceName}
                                        value={parem?.Weightage}
                                        onChange={(e) => {
                                            let value = Number(onlyNumeric(e.target.value))

                                            if (value <= 100) {
                                                handleOnChnage(
                                                    parem.HotelSequenceId,
                                                    e.target.name,
                                                    Number(onlyNumeric(e.target.value)) > 0 ? Number(onlyNumeric(e.target.value)) : ''
                                                )
                                            }
                                        }}
                                    />
                                    {formError[index] && <p className='mb-0 fs-6 text-danger'>{formError[index]}</p>}
                                </td>
                                <td className='align-content-center'>
                                    <div class="form-check">
                                        <input
                                            className="form-check-input cursor_pointer"
                                            type="checkbox"
                                            value="IsActive"
                                            name='IsActive'
                                            id={parem.HotelSequenceName + 'isActive'}
                                            checked={parem.IsActive}
                                            onChange={(e) => handleOnChnage(parem.HotelSequenceId, e.target.name, e.target.checked)}
                                        />
                                        <label
                                            className="form-check-label cursor_pointer"
                                            htmlFor={parem.HotelSequenceName + 'isActive'}
                                        >
                                            Active
                                        </label>
                                    </div>
                                </td>
                            </tr>
                        ))}

                        <tr>
                            <th className='align-content-center' scope="row">Total</th>
                            <td className='align-content-center'>{totalWeightage}</td>
                            <td className='align-content-center'></td>
                        </tr>

                    </tbody>
                </table>
                <div className='text-start'>
                    <p className='text-danger text-start fs-5'>* {" "} The sum of above weightage should be always equal 100</p>
                </div>
                <div className="text-end">
                    <button
                        type="button"
                        className="btn btn-primary mx-1"
                        id="btnSearch"
                        disabled={APISequencing===seqData}
                        onClick={() => handleReset()}
                    >Reset</button>
                    <button
                        type="button"
                        className="btn btn-primary mx-1"
                        id="btnSearch"
                        disabled={isSaveDisable || saveDisable || !useradd || !useredit}
                        onClick={() => handleSave(APISequencing)}
                    > {parameterWeightage(seqData)<=0?'Save':parameterWeightage(APISequencing)>0&&!saveDisable?'Update':'Save'}</button>
                </div>
            </div>
        </div>
    )
}

export default APISetSequencing